import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

/**
 * A simple selector which returns the set of mutators available in the Cube domain.
 * @returns
 */
export const useMutators = () => {
  const ctx = useCubeContext()

  return {
    mutators: ctx.mutators
  }
}
